import React, { useEffect, useState } from 'react';

import { productApi as api } from 'api/product';
import { FormComponent, Notifications } from 'shared';

const displayNewMemberField = (formdata) => formdata.offerType === 'new_member';
const displayRenewalField = (formdata) => formdata.offerType === 'renewal';

const formFields = [
    /**
     * Common Form Section, used for all the discount types
     */
    { name: 'name', inputElement: 'textField', label: 'Offer Name', gridValue: 6, inputProps: { required: true } },
    {
        name: 'offerType',
        inputElement: 'select',
        label: 'Offer Type',
        gridValue: 6,
        inputProps: {
            required: true,
            opts: [
                { text: 'New Member', value: 'new_member' },
                { text: 'Renewal', value: 'renewal' },
            ],
        },
    },
    {
        name: 'creditsValue',
        inputElement: 'textField',
        label: 'Credits Value',
        gridValue: 6,
        inputProps: { required: true },
        disabled: displayNewMemberField,
        display: displayNewMemberField,
    },
    {
        name: 'creditsDurationDays',
        inputElement: 'textField',
        label: 'Credit Expiry Days',
        gridValue: 6,
        inputProps: { required: true },
        disabled: displayNewMemberField,
        display: displayNewMemberField,
    },
    {
        name: 'discountType',
        inputElement: 'select',
        label: 'Discount Type',
        gridValue: 6,
        inputProps: {
            required: true,
            opts: [
                { text: 'Percentage', value: 'percent' },
                { text: 'Dollar Amount', value: 'dollar' },
            ],
        },
        disabled: displayRenewalField,
        display: displayRenewalField,
    },
    {
        name: 'discountAmount',
        inputElement: 'textField',
        label: 'Discount Amount',
        gridValue: 6,
        inputProps: { required: true },
        disabled: displayRenewalField,
        display: displayRenewalField,
    },
];

function CreatePlusMembershipOffer() {
    const [notification, setNotification] = useState({ text: null, level: null });

    return (
        <div>
            <h1>Create Plus Membership Offer </h1>
            <Notifications options={notification} />
            <div>
                <FormComponent
                    formFields={formFields}
                    onSubmit={async (formData, resetForm) => {
                        const response = await api.createPlusMembershipOffer(formData);
                        if (response.status === false) {
                            setNotification({
                                text: `Unable to create plus membership offer ${response.msg}`,
                                level: 'error',
                            });
                            return;
                        }

                        setNotification({ text: 'Success!', level: 'success' });
                        resetForm();
                    }}
                />
            </div>
        </div>
    );
}

export { CreatePlusMembershipOffer };
